<template lang="pug">
#bloco-dados-certificacao
    h2.titulo-bloco-dados-gerais-certificacao Dados gerais do território
    el-card(shadow='never', :body-style='{ padding: "16px" }')
        .bloco-dados-gerais-certificacao__linha
            .bloco-dados-gerais-certificacao-informacao
                h4 CAR’s vinculados
                .bloco-dados-gerais-certificacao-informacao__paragrafo
                    .lista-scroll
                        p(
                            v-for='(car, index) in dadosCertificacao.cars',
                            :key='index'
                        ) {{ car.codigo }}

            .bloco-dados-gerais-certificacao-informacao
                h4 Localidade
                .bloco-dados-gerais-certificacao-informacao__paragrafo
                    p {{ dadosCertificacao.dadosTerritorio[0].municipioTerritorioNome }} / {{ dadosCertificacao.dadosTerritorio[0].estadoTerritorioSigla }}

            .bloco-dados-gerais-certificacao-informacao
                h4 Pessoas
                .bloco-dados-gerais-certificacao-informacao__paragrafo
                    .lista-scroll
                        p(
                            v-for='(pessoa, index) in dadosCertificacao.representantes',
                            :key='index'
                        ) {{ pessoa.nomeRepresentante }}

            .bloco-dados-gerais-certificacao-informacao
                h4 Data da análise
                .bloco-dados-gerais-certificacao-informacao__paragrafo
                    p {{ dadosCertificacao.dataAnalise ? dadosCertificacao.dataAnalise : '--' }}

            .bloco-dados-gerais-certificacao-informacao
                h4 Ano da última safra
                .bloco-dados-gerais-certificacao-informacao__paragrafo
                    p {{ dadosCertificacao.safra }}
</template>

<script>
export default {
    name: 'BlocoDadosGeraisCertificacao',
    components: {},

    props: {
        dadosCertificacao: {
            type: Object,
            required: true
        }
    },

    data() {
        return {};
    },

    methods: {}
};
</script>

<style lang="scss" scoped>
#bloco-dados-certificacao {
    .titulo-bloco-dados-gerais-certificacao {
        font-weight: bold;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }
    .bloco-dados-gerais-certificacao__linha {
        display: flex;
        justify-content: space-between;

        h4 {
            font-weight: bold;
            color: var(--primary);
        }

        .bloco-dados-gerais-certificacao-informacao {
            min-width: 155px;

            .bloco-dados-gerais-certificacao-informacao__paragrafo {
                margin-top: 9px;
                .lista-scroll {
                    max-height: 110px;
                    overflow-y: auto;
                    display: flex;
                    flex-direction: column;
                    min-height: 70px;
                    padding: 0px;

                    p {
                        margin-bottom: 2px;
                    }
                }
            }
        }
    }
}
</style>
